export enum ContentActionEnum {
  Read = 'read',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Publish = 'publish',
  UnPublish = 'unpublish',
}
